var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-videos-wrapper"},[_c('ListHeader',{staticClass:"vidoes-list-header",attrs:{"listTitle":"我的视频"},on:{"query-list":_vm.getVideos}}),_c('VideoList',{ref:"videoListRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }